// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1647":"29c7165436edd3f7","2888":"4784522d96078eb9"}[chunkId] + ".css";
};